import clsx from "clsx";
import React, { useState } from "react";
import { getYear } from "../../../formatters";
import { Barometer } from "../../../types";

interface Props {
  className?: string;
  barometer: Barometer;
}

export function StudyInfo({ className, barometer }: Props) {
  const [toggled, setToggled] = useState(false);

  return (
    <div className={className}>
      <div className="flex justify-between">
        <span className="mb-3 w-full">
          <RenderItem
            title="Studiets titel"
            info={barometer.study?.title}
            link={barometer.study?.link}
          />
        </span>
        {(barometer.journal || barometer.published || barometer.doi) && (
          <div>
            <ToggleBtn toggled={toggled} onToggle={setToggled} />
          </div>
        )}
      </div>
      <div
        className={clsx(
          "transition-all duration-500 overflow-hidden grid gap-y-3",
          {
            "max-h-36 ease-out": toggled,
            "max-h-0 ease-in": !toggled,
          }
        )}
      >
        <RenderItem title="Tidsskrift" info={barometer.journal} />
        <RenderItem title="Udgivelsesår" info={getYear(barometer.published)} />
        <RenderItem title="DOI" info={barometer.doi} />
      </div>
    </div>
  );
}

interface RenderItemProps {
  title: string;
  info: string | undefined;
  link?: string;
}

function RenderItem({ title, info, link }: RenderItemProps) {
  if (!info) return null;
  return (
    <div
      className={clsx("flex text-left sm:items-center", {
        "flex-col sm:flex-row": link,
        "items-center": !link,
      })}
    >
      <span className="text-sm uppercase w-36 sm:flex-150">{title}</span>
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        className={clsx({
          link: link,
        })}
      >
        {info}
      </a>
    </div>
  );
}

interface ToggleBtnProps {
  onToggle: (val: boolean) => void;
  toggled?: boolean;
}
function ToggleBtn({ onToggle, toggled }: ToggleBtnProps) {
  const toggle = () => {
    onToggle(!toggled);
  };

  return (
    <button
      onClick={toggle}
      className={clsx(
        "justify-center flex rounded-full border-2 transition duration-500 w-8 h-8",
        {
          "rotate-90": !toggled,
          "-rotate-90": toggled,
        }
      )}
      style={{ borderColor: "#eaeaea" }}
    >
      <img
        src={require("../../../assets/icons/arrow.png")}
        className="h-[28px] w-[18px] p-1"
        alt="pil"
      />
    </button>
  );
}
